import { Descriptions } from "antd";
import { enmEvaluationStatus, IDamageCase } from "../../baseInfo/damageCase/interfaces";
import { Center } from "../../baseInfo/center";
import DataForm from "../../components/entityManager/dataform";
import { enmControlType, enmPropertyType, IProperty } from "../../components/entityManager/interfaces";
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { Core } from "../../components/infrastructure/core";
import { enmEntityState, ICallOptions } from "../../components/infrastructure/models";
import { IDamageCaseEvaluator } from "./interfaces";
import { ICenterProps } from "../../baseInfo/center/interfaces";

export interface IAllocateEvaluatorProps extends IBaseProps {
    damageCase: IDamageCase;
}

interface IAllocateEvaluatorStates extends IBaseStates {
    currentEntity: IDamageCaseEvaluator;
}

export class AllocateEvaluator extends BaseComponent<IAllocateEvaluatorProps, IAllocateEvaluatorStates> {
    properties: IProperty[];
    constructor(props: IAllocateEvaluatorProps) {
        super(props)
        this.properties = [
            {
                dataIndex: "EvaluatorId",
                title: "مرکز ارزیابی",
                propertyType: enmPropertyType.number,
                controlType: enmControlType.lookup,
                lookup: {
                    lookupComponent: Center,
                    lookupProperty: "Evaluator",
                    lookupDisplayFields: ["NationalCode", "FullName"]
                }
            }
        ];

        this.state = {
            isAuthorized: true,
            loading: true,
            currentEntity: {
                RowGuid: Core.newId(),
                DamageCaseId: this.props.damageCase.Id,
                Substatus: enmEvaluationStatus.DocumentCheck,
                State: enmEntityState.Added,
                ModifiedProperties: ["DamageCaseId", "Substatus"]
            } as any,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };

        if (this.props.damageCase.DefaultEvaluator) {
            this.state.currentEntity.EvaluatorId = this.props.damageCase.DefaultEvaluatorId ?? 0;
            this.state.currentEntity.Evaluator = this.props.damageCase.DefaultEvaluator;
            this.state.currentEntity.ModifiedProperties.push("EvaluatorId");
        }
    }
    componentDidMount() {
        super.componentDidMount();
        this.setState({ loading: false });
    }
    async save(entity: IDamageCaseEvaluator): Promise<boolean> {
        if (!entity)
            return false;

        let data: any = {};
        if (entity.State === enmEntityState.Modified || entity.State === enmEntityState.Added) {
            for (var i = 0; i < entity.ModifiedProperties.length; i++) {
                let val = entity.ModifiedProperties[i];
                data[val] = (entity as any)[val];
            }
        }

        data.State = enmEntityState.Added;
        data.RowGuid = entity.RowGuid;

        let fetchOpt: ICallOptions = {
            url: "damagecaseevaluator/allocateevaluator",
            data: { entity: data },
            onSuccess: (result) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification('ارزیاب با موفقیت اختصاص داده شد');
                    this.props.onClose && this.props.onClose(this);
                }
            }
        };
        return await this.callApi(fetchOpt);
    }

    virtualRender() {
        const extraHeaderNodes = () => {
            const damageCase = this.props.damageCase;
            const policy = damageCase.PolicyEquipmentModel.Policy;
            const policyholderNationalCode = policy.Policyholder?.NationalCode;
            const policyholderFullName = policy.Policyholder?.FullName;

            return (
                <Descriptions column={{ xxl: 4, xl: 4, lg: 2, md: 2, sm: 1, xs: 1 }} className="header-page">
                    <Descriptions.Item label="شماره پرونده خسارت">{damageCase.Code}</Descriptions.Item>
                    <Descriptions.Item label="شماره تیکت">{damageCase.TicketNo}</Descriptions.Item>
                    {damageCase.DamageType
                        ? <Descriptions.Item label="نوع خسارت">{damageCase.DamageType?.Name}</Descriptions.Item>
                        : <Descriptions.Item label="دلیل خسارت">{damageCase.DamageReason}</Descriptions.Item>
                    }
                    <Descriptions.Item label="بیمه گزار/مشتری">{policyholderFullName + " " + policyholderNationalCode}</Descriptions.Item>
                    <Descriptions.Item label="سریال بیمه نامه">{policy.SerialNo}</Descriptions.Item>
                    {damageCase.Province ? <Descriptions.Item label="استان">{damageCase.Province.Name}</Descriptions.Item> : <></>}
                    {damageCase.City ? <Descriptions.Item label="شهر">{damageCase.City.Name}</Descriptions.Item> : <></>}
                    {damageCase.DefaultEvaluator && <Descriptions.Item label="ارزیاب انتخابی بیمه گزار/مشتری">{damageCase.DefaultEvaluator.FullName}</Descriptions.Item>}
                </Descriptions>
            );
        };

        const header = this.getPageHeader({
            title: "تخصیص مرکز ارزیابی",
            onBack: () => { this.props.onClose && this.props.onClose(this) },
            extraHeaderNodes: extraHeaderNodes()
        });

        return (
            <>
                {header}
                <div>
                    <DataForm<IDamageCaseEvaluator>
                        parent={this}
                        resetable={false}
                        currentEntity={this.state.currentEntity}
                        properties={this.properties}
                        onSubmit={() => this.save(this.state.currentEntity)}
                        onChange={(property, value) => {
                            let currentEntity = this.state.currentEntity as any;
                            if (currentEntity && property.dataIndex === "EvaluatorId") {
                                currentEntity[property.dataIndex!] = value ? value["Id"] : 0;
                                if (currentEntity.ModifiedProperties.indexOf("EvaluatorId") === -1)
                                    currentEntity.ModifiedProperties.push("EvaluatorId");
                            }
                            this.setState({ currentEntity });
                        }}
                        preparelookupProps={(propName, lookupProps) => {
                            if (propName === "EvaluatorId")
                                (lookupProps as ICenterProps).isEvaluator = true;

                            return lookupProps;
                        }}
                    />
                </div>
            </>
        );
    }
}